import { Injectable, inject, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavvisSiteInfo } from '../api/middleware-api.service';

const STORAGE_KEY = 'selectedSite';

@Injectable({
	providedIn: 'root',
})
export class SiteService {
	private injector = inject(Injector);
	private selectedSiteSubject = new BehaviorSubject<NavvisSiteInfo | null>(this.loadFromStorage());

	selectedSite$: Observable<NavvisSiteInfo | null> = this.selectedSiteSubject.asObservable();

	get selectedSite(): NavvisSiteInfo | null {
		return this.selectedSiteSubject.value;
	}

	selectSite(site: NavvisSiteInfo): void {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(site));
		this.selectedSiteSubject.next(site);
		// Preload favorites for the selected site
		this.preloadFavorites();
	}

	clearSite(): void {
		sessionStorage.removeItem(STORAGE_KEY);
		this.selectedSiteSubject.next(null);
		// Clear favorites cache when site changes
		this.clearFavoritesCache();
	}

	private preloadFavorites(): void {
		// Lazy inject to avoid circular dependency
		import('../services/favorite-poi.service').then(m => {
			const favoritePoiService = this.injector.get(m.FavoritePoiService);
			favoritePoiService.preloadFavorites();
		});
	}

	private clearFavoritesCache(): void {
		// Lazy inject to avoid circular dependency
		import('../services/favorite-poi.service').then(m => {
			const favoritePoiService = this.injector.get(m.FavoritePoiService);
			favoritePoiService.clearCache();
		});
	}

	private loadFromStorage(): NavvisSiteInfo | null {
		const stored = sessionStorage.getItem(STORAGE_KEY);
		if (stored) {
			try {
				return JSON.parse(stored) as NavvisSiteInfo;
			} catch {
				return null;
			}
		}
		return null;
	}
}
